import React from "react";
import * as XLSX from "xlsx";
import { Box, Button, Tooltip } from "@mui/material";
import { DownloadSharp } from "@mui/icons-material";

const DownloadReport = ({ data, startDate, endDate }) => {

    const formatDateTime = (utcString) => {
        if (!utcString) return "";
        const date = new Date(utcString);
        return date.toLocaleString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    };
    const handleDownload = () => {
        if (!data) return;

        // Extract summary info
        const summaryData = [
            { Label: "Total Messages", Value: data.total_message },
            { Label: "Pending", Value: data.total_pending_count },
            { Label: "Failed", Value: data.total_failed_count },
            { Label: "Completed", Value: data.total_complete_count },
            { Label: "Read", Value: data.total_read_count },
            { Label: "Delivered", Value: data.total_delivered_count },
            { Label: "Start Date", Value: startDate },
            { Label: "End Date", Value: endDate },
        ];

        // Prepare detailed records (if available)
        const detailedData = data.result?.map((item, index) => ({
            SNo: index + 1,
            Phone: item.phone_number,
            Status: item.status,
            // Message: item.message,
            Priority : item.message_priority,
            Created_At : formatDateTime(item.created_at),
            Updated_At: formatDateTime(item.updated_at),
        })) || [];

        // Create separate sheets for summary and detailed results
        const workbook = XLSX.utils.book_new();
        const summarySheet = XLSX.utils.json_to_sheet(summaryData);
        XLSX.utils.book_append_sheet(workbook, summarySheet, "Summary");

        if (detailedData.length > 0) {
            const detailSheet = XLSX.utils.json_to_sheet(detailedData);
            XLSX.utils.book_append_sheet(workbook, detailSheet, "Detailed Report");
        }

        // Generate file name
        const filename = `whatsapp_report_${startDate}_to_${endDate}.xlsx`;

        // Download file
        XLSX.writeFile(workbook, filename);
    };

    return (
        <Box sx={{ width: "auto", height: "auto" }}>
            <Button variant="contained" color="primary" onClick={handleDownload}>
                <Tooltip title="Download WhatsApp Report">
                    <DownloadSharp />
                </Tooltip>
            </Button>
        </Box>
    );
};

export default DownloadReport;
